import { useConnect } from "wagmi";
import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";

type AccountGuardProps = {
  yeyElement: JSX.Element;
  neyElement: JSX.Element;
};

const AccountGuard = ({ yeyElement, neyElement }: AccountGuardProps) => {
  const [
    {
      data: { connected: isConnected },
      loading: isLoading,
    },
  ] = useConnect();

  if (isLoading) {
    return (
      <Center h="100vh">
        <BoldSpinner size="xl" />
      </Center>
    );
  }

  return isConnected ? yeyElement : neyElement;
};

export default AccountGuard;
